import ModuleTwoSelfEvaluation from "../../../../src/components/forms/ModuleTwoSelfEvaluation";
import * as React from 'react';
export default {
  ModuleTwoSelfEvaluation,
  React
};